/* MoonCommerce PDP — Smart Picker + Build Your Pack
   Custom elements for state and AJAX cart. Self-contained. */
(function () {
  if (window.MC_PDP_LOADED) return;
  window.MC_PDP_LOADED = true;

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        const fmt = (window.theme && window.theme.moneyFormat) || (window.Shopify.money_format) || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      } catch (e) { /* fall through */ }
    }
    return '$' + (cents / 100).toFixed(2);
  };

  /* ============================================================
     Smart color name → hex resolver
     Strategy (in order, first hit wins):
       1. Direct hit in expanded dictionary (~200 entries)
       2. Browser's native CSS color parser (140+ named colors + hex/rgb/hsl)
       3. Modifier prefix ("dark X", "light X", "dusty X", etc.) — adjust base
       4. Last-word match in dictionary or CSS
       5. Deterministic hash → muted HSL color (never gray)
     ============================================================ */
  const COLOR_DICTIONARY = {
    /* Black / very dark */
    black: '#1a1a1a', jet: '#161616', ink: '#1c1c1c', onyx: '#1a1a1a',
    ebony: '#181818', raven: '#1c1c1c', midnight: '#0d1224', noir: '#1a1a1a',
    obsidian: '#15141a', coal: '#1a1a1a',

    /* White / off-white */
    white: '#ffffff', snow: '#fafafa', pearl: '#ebe3d3', ivory: '#f1ead9',
    cream: '#f1ead9', vanilla: '#ebdfb9', eggshell: '#f0ead6', linen: '#e7dfd2',
    oat: '#dfd5c2', oatmeal: '#dfd5c2', bone: '#e0d8c5', alabaster: '#f2eee0',
    coconut: '#f3ecd9', porcelain: '#f5f0e6', chalk: '#f4ede1',

    /* Beige / nude / sand */
    beige: '#cabba6', stone: '#cabba6', sand: '#cabba6', tan: '#bda57f',
    taupe: '#a59585', mushroom: '#a5907e', ecru: '#c8b89c', nude: '#d1a87d',
    camel: '#b08c6a', biscuit: '#bea886', wheat: '#d4b88b', latte: '#b69b75',
    champagne: '#d6c2a1', sandstone: '#b09d7f', khaki: '#a89968', desert: '#c2a378',
    almond: '#cab48a', honey: '#d4a23b', butterscotch: '#c79350',

    /* Brown */
    brown: '#5e3a22', chocolate: '#4a2c1a', espresso: '#3d2817',
    darkchocolate: '#2e1a0e', mocha: '#785c46', coffee: '#503820',
    cocoa: '#5e3a22', cognac: '#8b4b29', caramel: '#a06d3c',
    chestnut: '#754f30', mahogany: '#4a1a1a', walnut: '#503820',
    toffee: '#85583a', ginger: '#a86b3a', russet: '#80432a',
    sepia: '#6f4624', auburn: '#6b3a1f', sienna: '#8a4626',
    hazelnut: '#9c6a3a', acorn: '#7a5234', umber: '#5b3a1f',
    bark: '#553523', earth: '#7a5a3a', tobacco: '#6a4a2a',

    /* Gray */
    gray: '#8b8b8b', grey: '#8b8b8b', charcoal: '#3c3c3c', slate: '#6a7480',
    smoke: '#6e6e6e', ash: '#a3a3a3', pewter: '#6c6c6c', graphite: '#4d4d4d',
    silver: '#c0c0c0', dove: '#9d9c98', fog: '#a8a9aa',
    heathergray: '#9c9c9c', heathergrey: '#9c9c9c', platinum: '#cfcfcf',
    steel: '#7a7d80', gunmetal: '#3a3f44', concrete: '#9b9a93',
    titanium: '#878684', cement: '#8e8c84',

    /* Red */
    red: '#a23030', crimson: '#7c1320', cherry: '#8b2528', tomato: '#cc3333',
    scarlet: '#a01a1a', ruby: '#9b1c1c', brick: '#8a3324', firered: '#bd1c1c',
    chili: '#a52a22', vermilion: '#b8362a', poppy: '#c14238',
    cardinal: '#94232b',

    /* Burgundy / wine */
    burgundy: '#6b1f2b', wine: '#6b1f2b', maroon: '#5c1d28', merlot: '#4f1e2f',
    bordeaux: '#591f29', oxblood: '#4d0f17', claret: '#691a25',
    mulberry: '#5e2942', sangria: '#69152a',

    /* Pink / coral / peach */
    pink: '#e7b9c1', blush: '#e7b9c1', rose: '#d09499',
    dustyrose: '#c89197', dustypink: '#d1a8a2',
    babypink: '#f1cfd6', hotpink: '#db5b94', neonpink: '#ff4d9d',
    fuchsia: '#b73a87', magenta: '#a83278', bubblegum: '#de7cae',
    flamingo: '#f08fa3', watermelon: '#d56870',
    salmon: '#d27a6a', coral: '#e07a5f', peach: '#e6a079',
    apricot: '#d49169', cantaloupe: '#e0a574',
    rosegold: '#c5867d', millennialpink: '#e1c3ce',
    fawn: '#dfb8b3', petal: '#e7c0c3', mauvepink: '#c6a2a8',

    /* Purple */
    purple: '#634e7d', plum: '#5b3a5b',
    eggplant: '#5d3954', aubergine: '#4f2e44',
    lavender: '#a89cc4', lilac: '#bcaad3', mauve: '#a86585',
    orchid: '#8a4983', violet: '#6c4280',
    amethyst: '#7a4b8a', wisteria: '#a385c6',
    iris: '#5d4e9c', grape: '#523566', boysenberry: '#572a4f',
    pansy: '#5e3a73', heather: '#a98ec1',

    /* Blue */
    blue: '#2a4982', navy: '#1f3155', royal: '#274ea1', denim: '#5673a0',
    skyblue: '#9cc4dd', sky: '#9cc4dd', babyblue: '#b6cee5', powderblue: '#b3cee0',
    cobalt: '#1a4eaa', sapphire: '#1d3d6b', indigo: '#2e3a5f',
    midnightblue: '#1c2347', electricblue: '#2a78cc', ocean: '#1d5b80',
    steelblue: '#4a6e8c', dustyblue: '#6b7f9c', cerulean: '#1d6fa5',
    azure: '#3287d4', aqua: '#7fdbd4', periwinkle: '#8a9adb',
    cornflower: '#6695d6', oxford: '#1c2a4a', petrol: '#27506a',
    horizon: '#5e80a8', oasis: '#3a8aa6',

    /* Teal / aqua / cyan */
    teal: '#2f6e6a', turquoise: '#3b9a96', seafoam: '#91d2c0',
    mint: '#a8d8b8', jade: '#2e8b6a', cyan: '#3aa6a6',
    lagoon: '#258a8a', tiffany: '#84cdcc',

    /* Green */
    green: '#3d5d3a', forest: '#2c4c2a', emerald: '#1f5e3a',
    olive: '#6b7a3f', sage: '#9bae8f', moss: '#5a6f3f',
    pine: '#2d4a36', fern: '#4f6c4a', hunter: '#355e3b',
    army: '#4b5320', military: '#4b5320', kelly: '#4cb050',
    shamrock: '#3a9554', basil: '#647f3c', avocado: '#7d8f4a',
    pistachio: '#a9b97d', lime: '#a3c93a', neongreen: '#2eff5e',
    grass: '#4f8a3a', meadow: '#6a8f4a',

    /* Yellow */
    yellow: '#e6c34a', mustard: '#c1972b', gold: '#c1972b',
    butter: '#ebd682', lemon: '#ebd34a', canary: '#ebd34a',
    saffron: '#d4a72c', maize: '#e3c548', marigold: '#dba429',
    honeycomb: '#d4a542', sunshine: '#ecc63a', daffodil: '#e8c93b',

    /* Orange */
    orange: '#d96b2c', rust: '#a8523d', tangerine: '#d76f3a',
    terracotta: '#b25538', paprika: '#a8462c', pumpkin: '#c66425',
    persimmon: '#c75233', copper: '#a85a31', bronze: '#855c34',
    amber: '#c98e2e', clay: '#a3593a', adobe: '#a44d2c',
    sunset: '#cf6f3a', ember: '#a8482d',

    /* Multi-word common phrases */
    forestgreen: '#2c4c2a', navyblue: '#1f3155', royalblue: '#274ea1',
    kellygreen: '#4cb050', limegreen: '#a3c93a', oliveggreen: '#6b7a3f',
    olivegreen: '#6b7a3f', mintgreen: '#a8d8b8', huntergreen: '#355e3b',
    seagreen: '#3a7459', emeraldgreen: '#1f5e3a', applegreen: '#7eb14b',
    brickred: '#8a3324', bloodred: '#7a161a', cherryred: '#8b2528',
    iceblue: '#cee4ee', oceanblue: '#1d5b80', deepocean: '#0e3a55',
    midnightnavy: '#0d1224',
  };

  let _cssTester = null;
  function cssTester() {
    if (!_cssTester) _cssTester = document.createElement('div');
    return _cssTester;
  }

  function isValidCSSColor(str) {
    if (!str) return false;
    const t = cssTester();
    t.style.color = '';
    t.style.color = String(str);
    return t.style.color !== '';
  }

  function normalizeKey(str) {
    return String(str).toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  let _canvasCtx = null;
  function canvasCtx() {
    if (!_canvasCtx) _canvasCtx = document.createElement('canvas').getContext('2d');
    return _canvasCtx;
  }

  /* Take any CSS-valid color string and return "#rrggbb" */
  function toHex(cssColor) {
    const ctx = canvasCtx();
    ctx.fillStyle = '#000';
    ctx.fillStyle = cssColor;
    const computed = ctx.fillStyle;
    // fillStyle returns "#rrggbb" for opaque colors, "rgba(r,g,b,a)" otherwise
    if (computed[0] === '#') return computed;
    const m = computed.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (m) return '#' + [m[1], m[2], m[3]].map(n => parseInt(n, 10).toString(16).padStart(2, '0')).join('');
    return computed;
  }

  /* Mix a hex color toward white (amount > 0) or black (amount < 0). 0..1 range. */
  function adjustLightness(hexColor, amount) {
    const hex = toHex(hexColor);
    if (!hex || hex[0] !== '#') return hexColor;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const target = amount > 0 ? 255 : 0;
    const f = Math.min(1, Math.max(0, Math.abs(amount)));
    const mix = (c) => Math.round(c + (target - c) * f);
    return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
  }

  /* Drop saturation by `amount` (0..1) — for "heather", "dusty", "muted" prefixes */
  function desaturate(hexColor, amount) {
    const hex = toHex(hexColor);
    if (!hex || hex[0] !== '#') return hexColor;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const gray = Math.round((r + g + b) / 3);
    const f = Math.min(1, Math.max(0, amount));
    const mix = (c) => Math.round(c + (gray - c) * f);
    return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
  }

  /* Deterministic muted color from a string (so two different names = two distinct colors). */
  function hashToColor(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
    const hue = Math.abs(h) % 360;
    const sat = 28 + (Math.abs(h >> 8) % 22);   // 28-50%
    const light = 48 + (Math.abs(h >> 16) % 16); // 48-64%
    return `hsl(${hue}, ${sat}%, ${light}%)`;
  }

  const MODIFIERS = {
    light: { kind: 'lighten', amount: 0.32 },
    pale: { kind: 'lighten', amount: 0.40 },
    soft: { kind: 'lighten', amount: 0.18 },
    pastel: { kind: 'lighten', amount: 0.35 },
    baby: { kind: 'lighten', amount: 0.42 },
    dark: { kind: 'darken', amount: 0.22 },
    deep: { kind: 'darken', amount: 0.30 },
    rich: { kind: 'darken', amount: 0.12 },
    bright: { kind: 'lighten', amount: 0.08 },
    neon: { kind: 'lighten', amount: 0.05 },
    electric: { kind: 'lighten', amount: 0.08 },
    dusty: { kind: 'desaturate', amount: 0.35 },
    muted: { kind: 'desaturate', amount: 0.40 },
    heather: { kind: 'desaturate', amount: 0.30 },
    faded: { kind: 'desaturate', amount: 0.45 },
    washed: { kind: 'desaturate', amount: 0.35 },
    smoky: { kind: 'desaturate', amount: 0.40 },
    midnight: { kind: 'darken', amount: 0.38 },
    burnt: { kind: 'darken', amount: 0.22 },
    hot: { kind: 'darken', amount: -0.05 }, // slight saturation boost handled as none
  };

  function applyModifier(baseColor, modName) {
    const mod = MODIFIERS[modName];
    if (!mod) return baseColor;
    if (mod.kind === 'lighten') return adjustLightness(baseColor, mod.amount);
    if (mod.kind === 'darken')   return adjustLightness(baseColor, -mod.amount);
    if (mod.kind === 'desaturate') return desaturate(baseColor, mod.amount);
    return baseColor;
  }

  function resolveColorOnce(name) {
    if (!name) return null;
    const lc = String(name).toLowerCase().trim();
    if (!lc) return null;

    // Direct dictionary lookup
    const key = normalizeKey(lc);
    if (COLOR_DICTIONARY[key]) return COLOR_DICTIONARY[key];

    // Browser-native CSS color (handles 140+ named colors, hex, rgb, hsl)
    if (isValidCSSColor(lc)) return lc;
    const nospace = lc.replace(/\s+/g, '');
    if (isValidCSSColor(nospace)) return nospace;

    return null;
  }

  function resolveColor(rawName) {
    if (!rawName) return null;
    // Whole-name dictionary/CSS hit first (handles "heather grey", "midnight navy", etc.)
    const direct = resolveColorOnce(rawName);
    if (direct) return direct;

    const words = String(rawName).toLowerCase().split(/[\s\-_/&,]+/).filter(Boolean);
    if (words.length >= 2) {
      // Separate descriptor words (light/dark/dusty/heather/soft…) from the actual
      // color noun. Apparel names like "Soft Pink Heather" or "Light Heather Beige"
      // stack descriptors around one real color — resolve the color, then apply the
      // descriptors. We pick the LAST non-descriptor word that resolves as the base
      // (the noun usually trails), so "heather"/"soft" don't get mistaken for it.
      const mods = [];
      let base = null;
      for (const w of words) {
        if (MODIFIERS[w]) { mods.push(w); continue; }
        const r = resolveColorOnce(w);
        if (r) base = r; // keep last resolvable non-descriptor word
      }
      if (base) {
        for (const m of mods) base = applyModifier(base, m);
        return base;
      }
      // Only descriptor words resolved (e.g. standalone "Heather"): use the descriptor
      // word's own dictionary color if it has one.
      for (let i = words.length - 1; i >= 0; i--) {
        const r = resolveColorOnce(words[i]);
        if (r) return r;
      }
    }

    // Last resort: deterministic hash, NEVER gray
    return hashToColor(String(rawName).toLowerCase());
  }

  /* ============================================================
     <mc-smart-picker>
     Holds the variant matrix and exposes state to the rest of the page.
     ============================================================ */
  class MCSmartPicker extends HTMLElement {
    constructor() {
      super();
      this.variants = [];
      this.optionNames = [];
      this.colorOptionIndex = -1;
      this.sizeOptionIndex = -1;
      this.fixedOptions = {}; // for products with >2 options — pin extras to first available
      this.selected = { color: null, size: null };
    }

    connectedCallback() {
      try {
        const dataEl = this.querySelector('script[type="application/json"][data-variants]');
        if (dataEl) {
          const parsed = JSON.parse(dataEl.textContent);
          this.variants = parsed.variants || [];
          this.optionNames = parsed.option_names || [];
        }
      } catch (e) {
        console.error('[mc-smart-picker] data parse failed', e);
      }

      this.colorOptionIndex = this.findOptionIndex(['color', 'colour', 'shade', 'finish', 'hue']);
      this.sizeOptionIndex = this.findOptionIndex(['size', 'length', 'fit']);

      const initVariantId = this.getAttribute('data-initial-variant-id');
      const initial = this.variants.find(v => String(v.id) === String(initVariantId)) || this.variants[0];
      if (initial) {
        if (this.colorOptionIndex >= 0) this.selected.color = initial.options[this.colorOptionIndex];
        if (this.sizeOptionIndex >= 0) this.selected.size = initial.options[this.sizeOptionIndex];
        // Pin any 3rd+ options to initial's value
        for (let i = 0; i < this.optionNames.length; i++) {
          if (i !== this.colorOptionIndex && i !== this.sizeOptionIndex) {
            this.fixedOptions[i] = initial.options[i];
          }
        }
      }

      this.resolveSwatchColors();
      this.bindInputs();
      this.updateAvailability();
      this.updateLabels();
      this.broadcast();
      // Mark ready AFTER the initial broadcast so the load-time sync doesn't
      // trigger a gallery image swap (the default image is already correct).
      this._ready = true;
    }

    /* Replace any server-rendered fallback (gray) with a JS-resolved color.
       Skips chips with a background image (merchant-set swatch image) or
       any non-gray color (merchant-set native swatch color). */
    resolveSwatchColors() {
      this.querySelectorAll('.mc-swatch').forEach(node => {
        const chip = node.querySelector('.mc-swatch__chip');
        if (!chip) return;
        if (chip.style.backgroundImage && chip.style.backgroundImage !== 'none') return;
        const current = (chip.style.backgroundColor || '').replace(/\s/g, '').toLowerCase();
        const isFallback = current === '' || current === 'rgb(221,221,221)' || current === '#ddd' || current === 'rgb(255,255,255)';
        if (!isFallback) return;
        const value = node.getAttribute('data-value');
        const resolved = resolveColor(value);
        if (resolved) chip.style.backgroundColor = resolved;
      });
    }


    findOptionIndex(needles) {
      const lower = this.optionNames.map(n => (n || '').toLowerCase());
      for (let i = 0; i < lower.length; i++) {
        if (needles.some(n => lower[i].includes(n))) return i;
      }
      return -1;
    }

    bindInputs() {
      this.querySelectorAll('input[data-mc-color]').forEach(input => {
        input.addEventListener('change', () => {
          if (input.checked) {
            this.selected.color = input.value;
            this.updateAvailability();
            this.updateLabels();
            this.broadcast();
          }
        });
      });

      this.querySelectorAll('input[data-mc-size]').forEach(input => {
        input.addEventListener('change', () => {
          if (input.checked) {
            this.selected.size = input.value;
            this.updateAvailability();
            this.updateLabels();
            this.broadcast();
          }
        });
      });
    }

    updateAvailability() {
      this.querySelectorAll('.mc-swatch').forEach(node => {
        const value = node.getAttribute('data-value');
        const anyVariant = this.findAnyVariant({ color: value });
        const available = anyVariant && anyVariant.available;
        node.setAttribute('data-soldout', available ? 'false' : 'true');
        const input = node.querySelector('input');
        if (input) input.dataset.available = available ? 'true' : 'false';
        node.setAttribute('data-checked', value === this.selected.color ? 'true' : 'false');
      });

      this.querySelectorAll('.mc-size').forEach(node => {
        const value = node.getAttribute('data-value');
        const variant = this.findVariant({ color: this.selected.color, size: value });
        const soldOut = !variant || !variant.available;
        node.setAttribute('data-soldout', soldOut ? 'true' : 'false');
        node.setAttribute('data-exists', variant ? 'true' : 'false');
        const input = node.querySelector('input');
        if (input) {
          // Keep real sold-out variants selectable for back-in-stock signup.
          input.disabled = !variant;
          input.dataset.available = soldOut ? 'false' : 'true';
        }
        node.setAttribute('data-checked', value === this.selected.size ? 'true' : 'false');
      });
    }

    findVariant({ color, size }) {
      return this.variants.find(v => {
        if (this.colorOptionIndex >= 0 && color != null && v.options[this.colorOptionIndex] !== color) return false;
        if (this.sizeOptionIndex >= 0 && size != null && v.options[this.sizeOptionIndex] !== size) return false;
        for (const k in this.fixedOptions) {
          if (v.options[k] !== this.fixedOptions[k]) return false;
        }
        return true;
      });
    }

    findAnyVariant({ color, size }) {
      return this.variants.find(v => {
        if (this.colorOptionIndex >= 0 && color != null && v.options[this.colorOptionIndex] !== color) return false;
        if (this.sizeOptionIndex >= 0 && size != null && v.options[this.sizeOptionIndex] !== size) return false;
        for (const k in this.fixedOptions) {
          if (v.options[k] !== this.fixedOptions[k]) return false;
        }
        return v.available;
      });
    }

    currentVariant() {
      return this.findVariant({ color: this.selected.color, size: this.selected.size });
    }

    updateLabels() {
      const colorVal = this.querySelector('[data-mc-color-value]');
      if (colorVal) colorVal.textContent = this.selected.color || '';
      const sizeVal = this.querySelector('[data-mc-size-value]');
      if (sizeVal) sizeVal.textContent = this.selected.size || '';
    }

    broadcast() {
      const variant = this.currentVariant();
      this.dispatchEvent(new CustomEvent('mc:variant-change', {
        bubbles: true,
        detail: {
          variant,
          color: this.selected.color,
          size: this.selected.size,
          colorIndex: this.colorOptionIndex,
          sizeIndex: this.sizeOptionIndex,
        }
      }));

      const productEl = this.closest('product-component') || document.querySelector('[data-product-component], product-component');
      const packBlock = productEl?.querySelector('.mc-pdp-byp-block');
      const notification = productEl?.querySelector('.mc-stock-notification');
      const unavailable = !variant || !variant.available;

      if (packBlock) packBlock.hidden = unavailable;
      if (notification) {
        notification.dataset.variantAvailable = unavailable ? 'false' : 'true';
        const notificationVariant = notification.querySelector('input[name="id"]');
        if (notificationVariant && variant) notificationVariant.value = variant.id;
      }

      if (variant) {
        const wrapper = this.closest('[data-form-wrapper]') || document;
        const hidden = wrapper.querySelector('input[name="id"]');
        if (hidden) hidden.value = variant.id;
        // Swap the gallery to this variant's featured image
        this.swapVariantImage(variant);
      }

      this.syncStockNotificationApp();

      if (productEl) {
        productEl.dispatchEvent(new CustomEvent('theme:variant:change', {
          detail: { variant },
          bubbles: true,
        }));
      }
    }

    syncStockNotificationApp() {
      clearTimeout(this.stockNotificationTimer);

      const refresh = (attempt = 0) => {
        const kbite = window.growConfig;
        if (!kbite || typeof kbite.onVariantChange !== 'function') return;
        if (kbite.processingOnVariantChange && attempt < 10) {
          this.stockNotificationTimer = setTimeout(() => refresh(attempt + 1), 100);
          return;
        }

        kbite.variantIdFormSelector = '.mc-stock-notification input[name="id"]';
        kbite.onVariantChange();
      };

      // Debounce quick color + size changes so Kbite reads the final combination.
      this.stockNotificationTimer = setTimeout(refresh, 150);
    }

    /* Swap the main product gallery to a variant's featured image. Works with the
       Broadcast theme's slide/thumb structure: [data-media-id$="-{mediaId}"]. */
    swapVariantImage(variant) {
      if (!this._ready) return; // don't swap during the initial load-time broadcast
      if (!variant || !variant.featured_media_id) return;
      const mediaId = variant.featured_media_id;
      // Find an active thumb link and "click" it — that triggers the theme's swap logic.
      const thumb = document.querySelector(`[data-thumb-link][data-media-id$="-${mediaId}"]`);
      if (thumb) {
        thumb.click();
        return;
      }
      // Fallback: scroll the matching slide into view
      const slide = document.querySelector(`[data-media-id$="-${mediaId}"]`);
      if (slide) {
        try {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        } catch (e) {
          slide.scrollIntoView();
        }
      }
    }

    getColors() {
      if (this.colorOptionIndex < 0) return [];
      const seen = new Set();
      const result = [];
      for (const v of this.variants) {
        const val = v.options[this.colorOptionIndex];
        if (!seen.has(val)) { seen.add(val); result.push(val); }
      }
      return result;
    }

    getSizes() {
      if (this.sizeOptionIndex < 0) return [];
      const seen = new Set();
      const result = [];
      for (const v of this.variants) {
        const val = v.options[this.sizeOptionIndex];
        if (!seen.has(val)) { seen.add(val); result.push(val); }
      }
      return result;
    }
  }
  if (!customElements.get('mc-smart-picker')) customElements.define('mc-smart-picker', MCSmartPicker);

  /* ============================================================
     <mc-build-your-pack>
     ============================================================ */
  class MCBuildYourPack extends HTMLElement {
    constructor() {
      super();
      this.tiers = [];
      this.basePrice = 0;
      this.activeTier = null;
      this.picker = null;
    }

    connectedCallback() {
      try {
        const cfg = JSON.parse(this.querySelector('script[type="application/json"][data-tiers]').textContent);
        this.tiers = cfg.tiers || [];
        this.basePrice = cfg.base_price || 0;
      } catch (e) {
        console.error('[mc-build-your-pack] config parse failed', e);
      }

      // Start from the radio that is actually checked, so the pack, the
      // highlighted card and what gets added to the cart always agree.
      const checkedTier = this.querySelector('input[data-mc-tier]:checked');
      const initialQty = parseInt(checkedTier ? checkedTier.value : this.getAttribute('data-initial-qty'), 10) || 1;
      this.activeTier = this.tiers.find(t => t.qty === initialQty) || this.tiers[0];
      this.querySelectorAll('.mc-byp__tier').forEach(card => {
        card.setAttribute('data-checked', card.querySelector('input').value === String(this.activeTier && this.activeTier.qty) ? 'true' : 'false');
      });

      this.picker = document.querySelector('mc-smart-picker');
      if (this.picker) {
        this.picker.addEventListener('mc:variant-change', () => {
          // Re-gate tiers against the newly selected variant's stock, then
          // update any rows the shopper hasn't personally customized.
          this.updateTierAvailability();
          this.syncUntouchedRows();
          this.updateTotals();
        });
      }

      this.bindTierInputs();
      this.bindCustomizeToggle();
      this.bindQuantity();
      this.bindSubmit();

      this.scheduleInit();
    }

    /* Initialize the pack UI. The picker sits earlier in the DOM, so it's already
       upgraded and ready when we connect — we init synchronously. We deliberately
       avoid requestAnimationFrame: rAF callbacks are paused in background/unfocused
       tabs (common for ad traffic that opens products in background tabs), which
       would leave the pack uninitialized until the tab gains focus. setTimeout
       still fires when backgrounded, so the fallback uses it. */
    scheduleInit() {
      const ready = () => this.picker && this.picker._ready;
      if (ready()) { this.initPack(); return; }
      let tries = 0;
      const wait = () => {
        if (!this.picker) this.picker = document.querySelector('mc-smart-picker');
        if (ready() || tries++ > 100) this.initPack();
        else setTimeout(wait, 16);
      };
      setTimeout(wait, 0);
    }

    initPack() {
      this.updateTierAvailability();
      this.renderRows();
      this.updateTotals();
    }

    /* Effective stock limit for a variant: Infinity if untracked or oversells,
       otherwise the inventory_quantity. */
    effectiveLimit(variant) {
      if (!variant) return 0;
      if (!variant.inventory_tracked || variant.inventory_policy === 'continue') return Infinity;
      // If quantity is hidden (Shopify can omit it), trust `available`.
      if (variant.inventory_quantity == null) return variant.available ? Infinity : 0;
      // Edge case: tracked+deny but qty=0 AND available=true is a contradiction;
      // means Shopify hid the count. Trust `available`.
      if (variant.inventory_quantity === 0 && variant.available) return Infinity;
      return Math.max(0, variant.inventory_quantity);
    }

    /* Stock cap for the CURRENTLY SELECTED variant (color + size from the picker).
       Infinity when there's no picker or the variant oversells / is untracked. */
    currentVariantCap() {
      if (!this.picker) return Infinity;
      const variant = this.picker.currentVariant();
      if (!variant) return Infinity;
      return this.effectiveLimit(variant);
    }

    /* A pack tier is sold out when the selected variant doesn't have enough
       units to fill the whole pack (e.g. only 8 in stock → 10-pack is sold out).
       Gated on the SELECTED variant only — no cross-color substitution. */
    updateTierAvailability() {
      if (!this.picker) return;
      const cap = this.currentVariantCap();
      this.querySelectorAll('.mc-byp__tier').forEach(card => {
        const input = card.querySelector('input');
        const qty = parseInt(input.value, 10);
        const insufficient = Number.isFinite(cap) && cap < qty;
        card.setAttribute('data-insufficient', insufficient ? 'true' : 'false');
        input.disabled = insufficient;
        let overlay = card.querySelector('.mc-byp__tier-overlay');
        if (insufficient) {
          if (!overlay) {
            overlay = document.createElement('span');
            overlay.className = 'mc-byp__tier-overlay';
            card.appendChild(overlay);
          }
          overlay.textContent = 'Sold out';
        } else if (overlay) {
          overlay.remove();
        }
      });
      // If the active tier no longer fits the selected variant, downgrade to the
      // largest tier that does (and rebuild the rows for the new quantity).
      if (this.activeTier && Number.isFinite(cap) && this.activeTier.qty > cap) {
        const downgrades = this.tiers.filter(t => t.qty <= cap).sort((a, b) => b.qty - a.qty);
        if (downgrades.length > 0) {
          this.activeTier = downgrades[0];
          const newInput = this.querySelector(`input[data-mc-tier][value="${this.activeTier.qty}"]`);
          if (newInput) {
            newInput.checked = true;
            this.querySelectorAll('.mc-byp__tier').forEach(card => {
              card.setAttribute('data-checked', card.querySelector('input').checked ? 'true' : 'false');
            });
            this.renderRows();
            this.updateTotals();
          }
        }
      }
    }

    bindTierInputs() {
      this.querySelectorAll('input[data-mc-tier]').forEach(input => {
        input.addEventListener('change', () => {
          if (input.checked && !input.disabled) {
            const qty = parseInt(input.value, 10);
            this.activeTier = this.tiers.find(t => t.qty === qty) || this.activeTier;
            this.querySelectorAll('.mc-byp__tier').forEach(card => {
              card.setAttribute('data-checked', card.querySelector('input').checked ? 'true' : 'false');
            });
            this.renderRows();
            this.updateTotals();
          }
        });
      });
    }

    bindCustomizeToggle() {
      const wrap = this.querySelector('.mc-byp__customize');
      if (!wrap) return;
      const toggle = wrap.querySelector('.mc-byp__customize-toggle');
      toggle.addEventListener('click', () => {
        const open = wrap.getAttribute('data-open') === 'true';
        wrap.setAttribute('data-open', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }

    bindQuantity() {
      const wrap = this.querySelector('.mc-byp__qty');
      if (!wrap) return;
      const input = wrap.querySelector('input');
      wrap.querySelector('[data-mc-qty-dec]').addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value, 10) - 1);
        this.updateTotals();
      });
      wrap.querySelector('[data-mc-qty-inc]').addEventListener('click', () => {
        input.value = Math.min(99, parseInt(input.value, 10) + 1);
        this.updateTotals();
      });
      input.addEventListener('change', () => {
        let v = parseInt(input.value, 10);
        if (!Number.isFinite(v) || v < 1) v = 1;
        if (v > 99) v = 99;
        input.value = v;
        this.updateTotals();
      });
    }

    renderRows() {
      const list = this.querySelector('[data-mc-rows]');
      if (!list) return;
      const qty = this.activeTier.qty;
      const banner = this.querySelector('[data-mc-banner]');
      if (banner) {
        const off = this.activeTier.discount;
        banner.innerHTML = 'Customize each piece' + (off > 0 ? ` · <strong>${off}% off applied to every piece</strong>` : '');
      }
      const colors = this.picker ? this.picker.getColors() : [];
      const sizes = this.picker ? this.picker.getSizes() : [];
      const customize = this.querySelector('.mc-byp__customize');

      if (colors.length === 0 && sizes.length === 0) {
        if (customize) customize.style.display = 'none';
        list.innerHTML = '';
        return;
      }
      if (customize) customize.style.display = '';

      const hasColor = colors.length > 0;
      const hasSize = sizes.length > 0;

      // Every piece defaults to the shopper's current selection. They can change
      // any individual piece below; tiers that exceed this variant's stock are
      // already disabled, so the default pack is always fulfillable.
      const primaryColor = this.picker ? this.picker.selected.color : null;
      const primarySize  = this.picker ? this.picker.selected.size  : null;

      let html = '';
      for (let i = 0; i < qty; i++) {
        const each = formatMoney(this.activeTier.unit_price_cents);
        const colorOpts = hasColor ? colors.map(c =>
          `<option value="${escapeHtml(c)}"${c === primaryColor ? ' selected' : ''}>${escapeHtml(c)}</option>`
        ).join('') : '';
        const sizeOpts = hasSize ? sizes.map(s =>
          `<option value="${escapeHtml(s)}"${s === primarySize ? ' selected' : ''}>${escapeHtml(s)}</option>`
        ).join('') : '';

        html += `
          <div class="mc-byp__row${hasColor && hasSize ? '' : ' mc-byp__row--single'}" data-mc-row="${i}">
            <span class="mc-byp__row-num">${i + 1}</span>
            ${hasColor ? `<select class="mc-byp__select" data-mc-select="color" autocomplete="off" aria-label="Color for item ${i + 1}">${colorOpts}</select>` : ''}
            ${hasSize ? `<select class="mc-byp__select" data-mc-select="size" autocomplete="off" aria-label="Size for item ${i + 1}">${sizeOpts}</select>` : ''}
            <span class="mc-byp__row-price">${each}</span>
          </div>`;
      }
      list.innerHTML = html;
      list.dataset.cols = (hasColor && hasSize) ? '2' : '1';

      list.querySelectorAll('select').forEach(sel => {
        sel.addEventListener('change', () => {
          sel.dataset.userTouched = 'true';
          this.validateRows();
          this.updateTotals();
        });
      });

      this.validateRows();
    }

    /* On a main color/size change, update only the rows the shopper hasn't
       personally edited — keeps their customizations, follows the headline pick
       for the rest. (Tier changes rebuild rows entirely via renderRows.) */
    syncUntouchedRows() {
      const list = this.querySelector('[data-mc-rows]');
      if (!list || !this.picker) return;
      const primaryColor = this.picker.selected.color;
      const primarySize  = this.picker.selected.size;
      list.querySelectorAll('.mc-byp__row').forEach(row => {
        const colorSel = row.querySelector('[data-mc-select="color"]');
        const sizeSel  = row.querySelector('[data-mc-select="size"]');
        if (colorSel && !colorSel.dataset.userTouched && primaryColor != null) colorSel.value = primaryColor;
        if (sizeSel && !sizeSel.dataset.userTouched && primarySize != null) sizeSel.value = primarySize;
      });
      this.validateRows();
    }

    /* Validate cumulative selections across all rows against per-variant inventory.
       Marks offending rows and disables Add to Cart if any conflict exists. */
    validateRows() {
      if (!this.picker) return true;
      const list = this.querySelector('[data-mc-rows]');
      if (!list) return true;

      const rows = Array.from(list.querySelectorAll('.mc-byp__row'));
      const used = {}; // variantId → count
      const variantByRow = []; // index → variant or null

      // Pass 1: collect usage and resolve variants
      rows.forEach((row) => {
        const colorSel = row.querySelector('[data-mc-select="color"]');
        const sizeSel = row.querySelector('[data-mc-select="size"]');
        const color = colorSel ? colorSel.value : null;
        const size = sizeSel ? sizeSel.value : null;
        const variant = this.picker.findVariant({ color, size });
        variantByRow.push(variant);
        if (variant) used[variant.id] = (used[variant.id] || 0) + 1;
      });

      // Pass 2: flag rows where usage exceeds inventory
      let allValid = true;
      rows.forEach((row, i) => {
        const variant = variantByRow[i];
        let problem = null;

        if (!variant || !variant.available) {
          problem = 'Sold out';
        } else {
          const limit = this.effectiveLimit(variant);
          if (Number.isFinite(limit)) {
            if (used[variant.id] > limit) {
              problem = limit === 0 ? 'Sold out' : `Only ${limit} available — change this row`;
            }
          }
        }

        if (problem) {
          row.setAttribute('data-row-error', problem);
          allValid = false;
        } else {
          row.removeAttribute('data-row-error');
        }

        // Update size dropdown options for this row's color (disable sold-out sizes)
        const colorSel = row.querySelector('[data-mc-select="color"]');
        const sizeSel = row.querySelector('[data-mc-select="size"]');
        if (colorSel && sizeSel) {
          const color = colorSel.value;
          Array.from(sizeSel.options).forEach(opt => {
            const v = this.picker.findVariant({ color, size: opt.value });
            opt.disabled = !v || !v.available;
          });
        }
      });

      const btn = this.querySelector('.mc-byp__atc');
      if (btn) {
        btn.dataset.invalid = allValid ? 'false' : 'true';
        btn.disabled = !allValid;
      }
      return allValid;
    }

    updateTotals() {
      const qty = parseInt(this.querySelector('.mc-byp__qty input').value, 10) || 1;
      const tier = this.activeTier;
      const total = tier.total_price_cents * qty;
      const totalEl = this.querySelector('[data-mc-atc-total]');
      if (totalEl) totalEl.textContent = formatMoney(total);
    }

    bindSubmit() {
      const btn = this.querySelector('.mc-byp__atc');
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (btn.dataset.loading === 'true') return;
        await this.addToCart(btn);
      });
    }

    async addToCart(btn) {
      const qtyMultiplier = parseInt(this.querySelector('.mc-byp__qty input').value, 10) || 1;
      this.clearError();

      const rows = Array.from(this.querySelectorAll('[data-mc-rows] .mc-byp__row'));
      const items = [];

      if (rows.length === 0) {
        const defaultId = parseInt(this.getAttribute('data-default-variant-id'), 10);
        if (!defaultId) { this.showError('No variant available to add.'); return; }
        items.push({ id: defaultId, quantity: this.activeTier.qty * qtyMultiplier });
      } else {
        if (!this.validateRows()) {
          this.showError('Please resolve the stock issues highlighted above.');
          return;
        }
        for (const row of rows) {
          const colorSel = row.querySelector('[data-mc-select="color"]');
          const sizeSel = row.querySelector('[data-mc-select="size"]');
          const color = colorSel ? colorSel.value : null;
          const size = sizeSel ? sizeSel.value : null;
          const variant = this.picker ? this.picker.findVariant({ color, size }) : null;
          if (!variant) {
            this.showError('Could not find a variant for one of your picks.');
            return;
          }
          items.push({ id: variant.id, quantity: qtyMultiplier });
        }
      }

      const merged = {};
      for (const it of items) merged[it.id] = (merged[it.id] || 0) + it.quantity;
      const payload = { items: Object.entries(merged).map(([id, q]) => ({ id: Number(id), quantity: q })) };

      btn.dataset.loading = 'true';
      const origLabel = btn.querySelector('.mc-byp__atc-label').textContent;
      btn.querySelector('.mc-byp__atc-label').textContent = 'Adding…';

      try {
        const res = await fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) {
          const errBody = await res.json().catch(() => ({}));
          throw new Error(errBody.description || errBody.message || 'Could not add to cart.');
        }
        // Notify the theme to refresh cart contents — Broadcast and others use these
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        window.dispatchEvent(new CustomEvent('cart:added'));

        // Open cart drawer — Broadcast exposes openCartDrawer() on the <cart-drawer>
        // element. Other themes use window.theme.openCartDrawer or [data-cart-toggle].
        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && typeof drawerEl.openCartDrawer === 'function') {
          drawerEl.openCartDrawer();
        } else if (window.theme && typeof window.theme.openCartDrawer === 'function') {
          window.theme.openCartDrawer();
        } else {
          // Final fallback: click a cart-toggle link if present, else redirect
          const toggle = document.querySelector('[data-cart-toggle]');
          if (toggle) toggle.click();
          else window.location.href = '/cart';
        }
      } catch (err) {
        this.showError(err.message);
      } finally {
        btn.dataset.loading = 'false';
        btn.querySelector('.mc-byp__atc-label').textContent = origLabel;
      }
    }

    showError(msg) {
      const el = this.querySelector('.mc-byp__error');
      el.textContent = msg;
      el.setAttribute('data-shown', 'true');
    }

    clearError() {
      const el = this.querySelector('.mc-byp__error');
      if (el) el.setAttribute('data-shown', 'false');
    }
  }
  if (!customElements.get('mc-build-your-pack')) customElements.define('mc-build-your-pack', MCBuildYourPack);

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  // Expose for debug / theme-side use
  window.MC_PDP = { resolveColor };
})();
